import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "dateui-weekdays" }
const _hoisted_3 = { class: "dateui-date" }
const _hoisted_4 = { class: "carousel-navigation" }

import {  onMounted, ref, provide } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";


interface AvailableDate {
  day: string;
  month: string;
  date: string;
}
  

export default /*@__PURE__*/_defineComponent({
  __name: 'Calendar',
  setup(__props, { expose: __expose }) {

const date = ref('')
const currentIndex = ref(-1)

const carouselConfig = {
  itemsToShow: 5,
  itemsToScroll: 5,
}

function setDate(idx: number) {
  date.value = ''
  currentIndex.value = idx
  const dateSelected = availableDates.value[idx]
  date.value = `${dateSelected.day} ${dateSelected.month}/${dateSelected.date}`
}

const availableDates = ref<AvailableDate[]>([]);
const slick = ref<any>(null);


const getNextTenDays = () => {
  const startDate = new Date(); 
  for (let i = 1; i <= 10; i++) {
    const x = new Date();
    x.setDate(startDate.getDate() + i);
    const dateComponent = x.toString().split(' ');
    availableDates.value.push({
      day: dateComponent[0],
      month: dateComponent[1],
      date: dateComponent[2].replace(/^0+/, ''),
    });
  }
};

onMounted(() => {
  getNextTenDays();
});

__expose({
  date
});

return (_ctx: any,_cache: any) => {
  return (availableDates.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Carousel), _mergeProps({ class: "calendar-slider" }, carouselConfig), {
          addons: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Navigation))
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDates.value, (availableDate, idx) => {
              return (_openBlock(), _createBlock(_unref(Slide), {
                onClick: ($event: any) => (setDate(idx)),
                key: availableDate.date
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(['dateui-card', { 'selected': currentIndex.value === idx }])
                  }, [
                    _createElementVNode("time", _hoisted_2, [
                      _createElementVNode("strong", null, _toDisplayString(availableDate.day), 1),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(availableDate.month) + " " + _toDisplayString(availableDate.date), 1)
                    ])
                  ], 2)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 16)
      ]))
    : _createCommentVNode("", true)
}
}

})